const project_datatable = payload => {
  return {
    type: "project_dataid",
    payload
  };
};

export default project_datatable;
